import React, { StrictMode, useState } from 'react';
import { Link } from 'react-router-dom';
import { post } from '../../utils/axios'; 
import AlertMsg from './AlertMsg';

function DetailButton({size,state,to}) {

    return (
        <StrictMode>
            <Link to={to} className="maincta" state={state} >
                <span> Details </span><img src="images/arrow.svg" alt="" />
            </Link>
        </StrictMode>
    )
}

export default DetailButton;